'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

import ModalSvc from './modal.service.js';

export default angular.module('georgeApp.modal', [])
  .factory('ModalSvc', ModalSvc)
  .name;
